import React from 'react'
import { BylineProps } from './Byline'
import { BylineProfile } from './components/BylineProfile'
import { BylineText } from './components/TheNightly/BylineText'
import { StyledByline } from './Byline.styled'
import { isContentPartner } from './helpers/isContentPartner'

export const TheNightlyByline: React.FC<BylineProps> = ({
    text,
    isFullWidth,
    profile,
    source,
    timestamp,
    readTimeMinutes,
}) => {

    return (
        <StyledByline isFullWidth={isFullWidth}>
            {profile && <BylineProfile profile={profile} />}
            <BylineText
                profile={profile}
                source={source}
                timestamp={timestamp}
                text={text}
                readTimeMinutes={readTimeMinutes!}
                isContentPartner={isContentPartner(source)}
            />
        </StyledByline>
    )
}